<template>
  <div class="sidebar-holder">
    <div class="sidebar-top">
      <div class="columns px-2 py-2 mb-1 is-mobile is-gapless is-vcentered">
        <div class="column logo-holder">
          <b-image
            :src="require('@/assets/logo.svg')"
            alt="qlipmark"
            class="logo"
          />
        </div>
        <div class="column is-flex-grow-0 has-text-primary logo-text">
          qlipmark
        </div>
      </div>
      <MainMenuContents />
    </div>

    <div class="sidebar-bottom">
      <ActionsMenuContents />
    </div>
  </div>
</template>

<script>
  import MainMenuContents from "@/views/_globals/MenuContents-Main.vue"
  import ActionsMenuContents from "@/views/_globals/MenuContents-Actions.vue"

  export default {
    components: {
      MainMenuContents,
      ActionsMenuContents,
    }
  }
</script>

<style lang="scss" scoped>
  .logo-holder {
    max-width: 50px;
  }

  .sidebar-holder {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
  }
</style>
